import { Button, Input, Popup, SearchBar, Selector, Toast } from 'antd-mobile';
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import API_ROUTES from '../../api';

const MEMBER_TYPE_OPTIONS = [
    { label: '临时队员', value: 1 },
    { label: '非正式', value: 3 },
    { label: '离队成员', value: 4 },
];

const POSITION_OPTIONS = [
    { label: '门将', value: '1' },
    { label: '防守', value: '3' },
    { label: '组织', value: '6' },
    { label: '进攻', value: '7' },
    { label: '裁判', value: '8' },
];

// 支持调用方注入统一入口样式，同时保留其他页面原有按钮样式。
const AddTempMember = ({ gameDetail, type, getGameDetailInfo, className = '' }) => {
    const userInfo = localStorage.getItem('memberInfo');
    const memberInfo = userInfo ? JSON.parse(userInfo) : null;
    const refereeListInfo = gameDetail?.currentUserInfo?.length > 0
        ? gameDetail.currentUserInfo.filter(item => item.gameType === 1 || item.gameType === 2)
        : [];
    const shouldDisplay = memberInfo?.admin === 1 || (refereeListInfo && refereeListInfo.some(referee => referee.id === memberInfo?.id));

    const [tempList, setTempList] = useState([]);
    const [inviteVisible, setInviteVisible] = useState(false);
    const [createVisible, setCreateVisible] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedMemberId, setSelectedMemberId] = useState('');
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [newMemberName, setNewMemberName] = useState('');
    const [newMemberType, setNewMemberType] = useState(null);
    const [newMemberPosition, setNewMemberPosition] = useState(null);
    const [newMemberTeam, setNewMemberTeam] = useState(null);

    useEffect(() => {
        getGameInfo();
    }, []);

    const teamOptions = useMemo(() => ([
        { label: gameDetail?.greenName || '绿队', value: 1 },
        { label: gameDetail?.redName || '红队', value: 2 },
    ]), [gameDetail?.greenName, gameDetail?.redName]);

    const filteredMembers = useMemo(() => {
        const keyword = searchText.trim();
        if (!keyword) return tempList;
        return tempList.filter(item => (item.name || '').includes(keyword));
    }, [tempList, searchText]);

    const closeInvitePopup = () => {
        setInviteVisible(false);
        setSearchText('');
        setSelectedMemberId('');
        setSelectedTeam(null);
    };

    const closeCreatePopup = () => {
        setCreateVisible(false);
        setNewMemberName('');
        setNewMemberType(null);
        setNewMemberPosition(null);
        setNewMemberTeam(null);
    };

    const getGameInfo = () => {
        Toast.show({ icon: 'loading' });
        axios.get(API_ROUTES.member_list, {
            params: {
                tempMember: '1,3,4',
            },
        })
            .then(function (response) {
                setTempList(response.data.data || []);
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
                Toast.clear();
            });
    };

    const inviteExistingMember = () => {
        if (!selectedMemberId) {
            Toast.show({ content: '请选择临时人员', icon: 'fail' });
            return;
        }
        if (type === 1 && !selectedTeam) {
            Toast.show({ content: '请选择队伍', icon: 'fail' });
            return;
        }

        Toast.show({ icon: 'loading', duration: 0 });
        axios.post(API_ROUTES.member_addTempMember, {
            memberId: selectedMemberId,
            team: selectedTeam,
            gameId: gameDetail.id,
        }, null)
            .then(function (response) {
                if (response.data.code === 200) {
                    getGameDetailInfo();
                    closeInvitePopup();
                    Toast.show({ icon: 'success', content: '邀请成功！' });
                } else {
                    Toast.show({ content: response.data.msg });
                }
            })
            .catch(function () {
                Toast.show({ icon: 'fail', content: '操作失败，请联系管理员！' });
            });
    };

    const createTempMember = () => {
        const memberName = newMemberName.trim();
        if (!memberName) {
            Toast.show({ icon: 'fail', content: '姓名不能为空！' });
            return;
        }
        if (!newMemberType) {
            Toast.show({ icon: 'fail', content: '人员类型不能为空！' });
            return;
        }
        if (!newMemberPosition) {
            Toast.show({ icon: 'fail', content: '人员位置不能为空！' });
            return;
        }
        if (type === 1 && !newMemberTeam) {
            Toast.show({ icon: 'fail', content: '队伍不能为空！' });
            return;
        }

        Toast.show({ icon: 'loading', content: '处理中...', duration: 0 });
        axios.post(API_ROUTES.member_addNewTempMember, {
            team: newMemberTeam,
            gameId: gameDetail.id,
            memberType: newMemberType,
            memberName,
            gameRole: newMemberPosition,
        }, null)
            .then(function (response) {
                if (response.data.code === 200) {
                    getGameInfo();
                    getGameDetailInfo();
                    closeCreatePopup();
                    closeInvitePopup();
                    Toast.show({ icon: 'success', content: '添加成功！' });
                } else {
                    Toast.show({ icon: 'fail', content: response.data.msg || '添加失败' });
                }
            })
            .catch(function () {
                Toast.show({ icon: 'fail', content: '操作失败，请联系管理员！' });
            });
    };

    if (!shouldDisplay) {
        return null;
    }

    return (
        <div style={{ width: '100%' }}>
            <button
                className={`admin-action-btn btn--invite ${className}`.trim()}
                style={{ width: '100%' }}
                onClick={() => setInviteVisible(true)}
            >
                <span className="premium-btn-icon">👤</span>
                <span className="ready-function-label">临时邀请</span>
                <span className="ready-function-arrow">›</span>
            </button>

            <Popup
                visible={inviteVisible}
                onMaskClick={closeInvitePopup}
                bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '86vh', overflow: 'hidden' }}
                style={{ '--z-index': 1200 }}
            >
                <div className="temp-invite-sheet">
                    <div className="temp-invite-header">
                        <button type="button" onClick={closeInvitePopup}>取消</button>
                        <div>
                            <div className="temp-invite-title">临时邀请</div>
                            <div className="temp-invite-subtitle">选择已有人员，或录入新成员</div>
                        </div>
                        <button type="button" className="primary" onClick={inviteExistingMember}>确认</button>
                    </div>

                    <div className="temp-invite-sticky">
                        <button
                            type="button"
                            className="temp-create-entry"
                            onClick={() => setCreateVisible(true)}
                        >
                            <span>+</span>
                            录入新的临时人员
                        </button>
                        {type === 1 && (
                            <div className="temp-form-block">
                                <div className="temp-form-label">选择队伍</div>
                                <Selector
                                    className="temp-chip-selector"
                                    columns={2}
                                    options={teamOptions}
                                    value={selectedTeam ? [selectedTeam] : []}
                                    onChange={value => setSelectedTeam(value[0] || null)}
                                />
                            </div>
                        )}
                        <SearchBar
                            className="temp-search"
                            placeholder="搜索姓名"
                            value={searchText}
                            onChange={setSearchText}
                        />
                    </div>

                    <div className="temp-member-scroll">
                        <div className="temp-member-grid">
                            {filteredMembers.map(item => {
                                const active = selectedMemberId === item.id;
                                return (
                                    <button
                                        key={item.id}
                                        type="button"
                                        className={`temp-member-cell ${active ? 'active' : ''}`}
                                        onClick={() => setSelectedMemberId(item.id)}
                                    >
                                        <span>{item.name}</span>
                                    </button>
                                );
                            })}
                        </div>
                        {filteredMembers.length === 0 && (
                            <div className="temp-empty">没有找到对应人员</div>
                        )}
                    </div>
                </div>
            </Popup>

            <Popup
                visible={createVisible}
                onMaskClick={closeCreatePopup}
                bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '88vh', overflow: 'hidden' }}
                style={{ '--z-index': 1300 }}
            >
                <div className="temp-create-sheet">
                    <div className="temp-invite-header">
                        <button type="button" onClick={closeCreatePopup}>取消</button>
                        <div>
                            <div className="temp-invite-title">录入新人</div>
                            <div className="temp-invite-subtitle">新增后会直接加入当前比赛</div>
                        </div>
                        <button type="button" className="primary" onClick={createTempMember}>保存</button>
                    </div>

                    <div className="temp-create-content">
                        <div className="temp-form-block">
                            <div className="temp-form-label">人员姓名</div>
                            <Input
                                className="temp-input"
                                placeholder="请输入姓名"
                                value={newMemberName}
                                onChange={setNewMemberName}
                            />
                        </div>

                        <div className="temp-form-block">
                            <div className="temp-form-label">人员类型</div>
                            <Selector
                                className="temp-chip-selector"
                                columns={3}
                                options={MEMBER_TYPE_OPTIONS}
                                value={newMemberType ? [newMemberType] : []}
                                onChange={value => setNewMemberType(value[0] || null)}
                            />
                        </div>

                        <div className="temp-form-block">
                            <div className="temp-form-label">位置偏好</div>
                            <Selector
                                className="temp-chip-selector"
                                // 五个位置按三列换行，直接展示完整选项。
                                columns={3}
                                options={POSITION_OPTIONS}
                                value={newMemberPosition ? [newMemberPosition] : []}
                                onChange={value => setNewMemberPosition(value[0] || null)}
                            />
                        </div>

                        {type === 1 && (
                            <div className="temp-form-block">
                                <div className="temp-form-label">分配队伍</div>
                                <Selector
                                    className="temp-chip-selector"
                                    columns={2}
                                    options={teamOptions}
                                    value={newMemberTeam ? [newMemberTeam] : []}
                                    onChange={value => setNewMemberTeam(value[0] || null)}
                                />
                            </div>
                        )}

                        <Button block className="temp-submit-btn" onClick={createTempMember}>
                            保存并邀请
                        </Button>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default AddTempMember;
